import {OrderDataDTO, QuoteDTO} from "@/api/data-contracts";
import {ModelAction} from "@/lib/modelstate";
import {getField, pathOf, setField} from "@/lib/accessor";
import {calcTotalPrice} from "@/model/request";
import {isDate} from "@/lib/utils";
import dayjs from "dayjs";

export const quoteReducer = (model: QuoteDTO, action: ModelAction) => {
    switch (action.type) {
        case "--onchange": {
            const field = action.data[0];
            switch (field) {
                case pathOf<QuoteDTO, OrderDataDTO>("orderData", "deliveryDateFrom"): {
                    if (isDate(model.orderData.deliveryDateFrom)) {
                        if (model.orderData.deliveryDateTo == null) {
                            return setField(
                                model,
                                pathOf<QuoteDTO, OrderDataDTO>("orderData", "deliveryDateTo"),
                                model.orderData.deliveryDateFrom
                            );
                        }
                        const differenceInDays = dayjs(model.orderData.deliveryDateTo).diff(
                            dayjs(model.orderData.deliveryDateFrom),
                            "day"
                        );
                        const newDateTo =
                            differenceInDays <= 0
                                ? model.orderData.deliveryDateFrom
                                : dayjs(model.orderData.deliveryDateFrom).add(differenceInDays, "day").toDate();

                        return setField(
                            model,
                            pathOf<QuoteDTO, OrderDataDTO>("orderData", "deliveryDateTo"),
                            newDateTo
                        );
                    }
                    break;
                }

                case pathOf<QuoteDTO, OrderDataDTO>("orderData", "deliveryDateTo"): {
                    if (isDate(model.orderData.deliveryDateFrom) && isDate(model.orderData.deliveryDateTo)) {
                        const differenceInDays = dayjs(model.orderData.deliveryDateTo).diff(
                            dayjs(model.orderData.deliveryDateFrom),
                            "day"
                        );
                        if (differenceInDays < 0) {
                            return setField(
                                model,
                                pathOf<QuoteDTO, OrderDataDTO>("orderData", "deliveryDateFrom"),
                                model.orderData.deliveryDateTo
                            );
                        }
                    }
                }
            }
            switch (true) {
                case /orderData\.quantityOptions\[\w+]/.test(field): {
                    const match = field.match(/(orderData\.quantityOptions\[\d+])\./);
                    if (match) {
                        const quantityField = `${match[1]}.quantity`;
                        const netPricePer1000Field = `${match[1]}.netPricePer1000`;
                        const netPriceTotalField = `${match[1]}.netPriceTotal`;
                        model = setField(
                            model,
                            netPriceTotalField,
                            calcTotalPrice(getField(model, netPricePer1000Field), getField(model, quantityField))
                        );
                    }
                    return model;
                }
            }
            return model;
        }
        default:
            return model;
    }
};
